import type { IndexPagination } from "@/types";

export type { IndexPagination };

export function paginationPages(pagination: Pick<IndexPagination, "current_page" | "total_pages">) {
  const startPage = Math.max(1, pagination.current_page - 2);
  const endPage = Math.min(pagination.total_pages, pagination.current_page + 2);
  const pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

  return [...new Set([1, ...pages, pagination.total_pages])].sort((first, second) => first - second);
}
